function ProductBrandLogos({ product }) {
  return (
    <div>
      {product.brand_facet.toLowerCase() === "shaw floors" ||
      product.brand_facet.toLowerCase() === "shaw" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/shaw-floors-logo.webp"
          alt="Shaw Logo"
        />
      ) : product.brand_facet.toLowerCase() === "anderson tuftex" ||
        product.brand_facet.toLowerCase() === "anderson tuftex builder" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/anderson-tuftex-logo.webp"
          alt="Anderson Tuftex"
        />
      ) : product.brand_facet.toLowerCase() === "karastan" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/karastan-logo.webp"
          alt="Karastan"
        />
      ) : product.brand_facet.toLowerCase() === "armstrong" ||
        product.brand_facet.toLowerCase() === "armstrong flooring" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/armstrong-logo.webp"
          alt="Armstrong"
        />
      ) : product.brand_facet.toLowerCase() === "dreamweaver" ||
        product.brand_facet.toLowerCase() === "dream weaver" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/dreamweaver_logo.webp"
          alt="Dream Weaver"
        />
      ) : product.brand_facet.toLowerCase() === "philadelphia commercial" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/philadelphia-commercial-logo.webp"
          alt="Philadelphia Commercial"
        />
      ) : product.brand_facet.toLowerCase() === "coretec" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/coretec-logo.webp"
          alt="COREtec"
        />
      ) : product.brand_facet.toLowerCase() === "daltile" ||
        product.brand_facet.toLowerCase() === "dal tile" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/daltile.webp"
          alt="Daltile"
        />
      ) : product.brand_facet.toLowerCase() === "mohawk" ||
        product.brand_facet.toLowerCase() === "mohawk build" ||
        product.brand_facet.toLowerCase() === "mohawk flooring" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/mohawk-logo.webp"
          alt="Mohawk"
        />
      ) : product.brand_facet.toLowerCase() === "bruce" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/bruce.webp"
          alt="Bruce"
        />
      ) : product.brand_facet.toLowerCase() === "american olean" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/american-olean.webp"
          alt="American Olean"
        />
      ) : product.brand_facet.toLowerCase() === "mannington" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/mannington.webp"
          alt="Mannington"
        />
      ) : product.brand_facet.toLowerCase() === "fabrica" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/fabrica-logo.webp"
          alt="Fabrica"
        />
      ) : product.brand_facet.toLowerCase() === "masland" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/masland.webp"
          alt="Masland"
        />
      ) : product.brand_facet.toLowerCase() === "dixie home" ||
        product.brand_facet.toLowerCase() === "dixiehome" ||
        product.brand_facet.toLowerCase() === "dh floors" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/dixie-home.webp"
          alt="Dixie Home"
        />
      ) : product.brand_facet.toLowerCase() === "nourison" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/nourison_logo.webp"
          alt="Nourison"
        />
      ) : product.brand_facet.toLowerCase() === "hydraluxe" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/hydraluxe_logo.webp"
          alt="Hydraluxe"
        />
      ) : product.brand_facet.toLowerCase() === "karndean" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/karndean.webp"
          alt="Karndean"
        />
      ) : product.brand_facet.toLowerCase() === "cali" ||
        product.brand_facet.toLowerCase() === "cali floors" ? (
        <img
          width="100"
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/cali-brand-logo.webp"
          alt="Cali"
        />
      ) : product.brand_facet.toLowerCase() === "canopy" ||
        product.brand_facet.toLowerCase() === "canopy floors" ? (
        <img
          width="100"
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/canopy.webp"
          alt="Canopy"
        />
      ) : product.brand_facet.toLowerCase() === "robbins" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Robbins.webp"
          alt="Robbins"
        />
      ) : product.brand_facet.toLowerCase() === "mercier" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/mercier-hardwood.webp"
          alt="Mercier"
        />
      ) : product.brand_facet.toLowerCase() === "hallmark" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/hallmark-floors.webp"
          alt="Hallmark"
        />
      ) : product.brand_facet.toLowerCase() === "bella cera" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/bellacera.webp"
          alt="Bella Cera"
        />
      ) : product.brand_facet.toLowerCase() === "godfrey hirst" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/godfrey-hirst.webp"
          alt="Godfrey Hirst"
        />
      ) : product.brand_facet.toLowerCase() === "stanton" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/stanton.webp"
          alt="Stanton"
        />
      ) : product.brand_facet.toLowerCase() === "emser" ||
        product.brand_facet.toLowerCase() === "emser tile" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/emser-tile.webp"
          alt="Emser"
        />
      ) : product.brand_facet.toLowerCase() === "marazzi" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/marazzi.webp"
          alt="Marazzi"
        />
      ) : product.brand_facet.toLowerCase() === "happy feet" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/happy_feet.webp"
          alt="Happy Feet"
        />
      ) : product.brand_facet.toLowerCase() === "happy floors" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Happy-floors-logo.webp"
          alt="Happy Floors"
        />
      ) : product.brand_facet.toLowerCase() === "somerset" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/somerset-hardwood.webp"
          alt="Somerset"
        />
      ) : product.brand_facet.toLowerCase() === "naturally aged flooring" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/naturally-aged-flooring.webp"
          alt="Naturally Aged Flooring"
        />
      ) : product.brand_facet.toLowerCase() === "msi tile" ||
        product.brand_facet.toLowerCase() === "msi" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/MSI.webp"
          alt="MSI Tile"
        />
      ) : product.brand_facet.toLowerCase() === "kingsmen" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/kingsmen_logo.webp"
          alt="Kingsmen"
        />
      ) : product.brand_facet.toLowerCase() === "5th and main" ||
        product.brand_facet.toLowerCase() === "5th & main" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/5thandmain-logo.webp"
          alt="5th And Main"
        />
      ) : product.brand_facet.toLowerCase() === "aladdin commercial" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Aladdin-Commercial.webp"
          alt="Aladdin Commercial"
        />
      ) : product.brand_facet.toLowerCase() === "nourtex" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Nourtex-nourison-logo.webp"
          alt="Nourtex"
        />
      ) : product.brand_facet.toLowerCase() === "kane" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/kane-carpet.webp"
          alt="Kane"
        />
      ) : product.brand_facet.toLowerCase() === "antrim" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/antrim-logo.webp"
          alt="Antrim"
        />
      ) : product.brand_facet.toLowerCase() === "hagaman" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Hagaman-nourison-logo.webp"
          alt="Hagaman"
        />
      ) : product.brand_facet.toLowerCase() === "hartco" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/hartco-hardwood.webp"
          alt="Hartco"
        />
      ) : product.brand_facet.toLowerCase() === "pergo" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/pergo.webp"
          alt="Pergo"
        />
      ) : product.brand_facet.toLowerCase() === "republic" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/republic.webp"
          alt="Republic"
        />
      ) : product.brand_facet.toLowerCase() === "shaw builder flooring" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/shaw-builder-logo.webp"
          alt="Shaw Builder Flooring"
        />
      ) : product.brand_facet.toLowerCase() === "provenza" ||
        product.brand_facet.toLowerCase() === "provenza floors" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/provenza.webp"
          alt="Provenza"
        />
      ) : product.brand_facet.toLowerCase() === "tarkett" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/tarkett-flooring.webp"
          alt="Tarkett"
        />
      ) : product.brand_facet.toLowerCase() === "trucor" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Trucor-logo.webp"
          alt="Trucor"
        />
      ) : product.brand_facet.toLowerCase() === "palmetto road" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/palmetto-road-logo.webp"
          alt="Palmetto Road"
        />
      ) : product.brand_facet.toLowerCase() === "couristan" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/couristan.webp"
          alt="Couristan"
        />
      ) : product.brand_facet.toLowerCase() === "paramount" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Paramount.webp"
          alt="Paramount"
        />
      ) : product.brand_facet.toLowerCase() === "jordans signature series" ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/signature_series.webp"
          alt="Jordans Signature Series"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("pet performance destination", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/CarpetsPlus_Pet_Perf_Destination_Logo.webp"
          alt="Pet Performance Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("color destination carpet collection", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Color_Destination_Logo.webp"
          alt="Color Destination Carpet Collection"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("pure color destination", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/PureColor_Destination_Logo.webp"
          alt="Pure Color Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("color destination", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Color_Destination_White_Logo.webp"
          alt="Color Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("elite performance home", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Elite_Performance_Home_Logo.webp"
          alt="Elite Performance Home"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("milan collection", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/milan_collection_logo.webp"
          alt="Milan Collection"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile prime luxury vinyl flooring", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_Prime_Luxury_Vinyl_Flooring_with_CT_tech.webp"
          alt="Colortile Prime Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile hd luxury vinyl flooring", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_HD_Lux_Vinyl_Flooring.webp"
          alt="Colortile HD Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile pro luxury vinyl flooring", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_Pro_Lux_Vinyl_Plank_Logo.webp"
          alt="Colortile Pro Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile pro luxury vinyl tile", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_Pro_Lux_Vinyl_Plank_Logo.webp"
          alt="Colortile Pro Luxury Vinyl Tile"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile pro luxury vinyl plank", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_Pro_Lux_Vinyl_Plank_Logo.webp"
          alt="Colortile Pro Luxury Vinyl Plank"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile pro waterproof performance flooring", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_Pro_Waterproof_Performance_Flooring_LVP.webp"
          alt="Colortile Pro Waterproof Performance Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile select luxury vinyl flooring", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_Select_LV_Flooring_Logo.webp"
          alt="Colortile Select Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile select premier luxury vinyl flooring", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_Select_Premier_LV_Flooring_Black_with_CT_tech.webp"
          alt="Colortile Select Premier Luxury Vinyl Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("hardwood destination", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Hardwood_Destination_Logo.webp"
          alt="Hardwood Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile ultra hd signature flooring", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_Ultra_HD_Signature_Flooring_Logo.webp"
          alt="Colortile Ultra HD Signature Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("home gallery tile 1.0", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Home_Gallery_1.0.webp"
          alt="Home Gallery Tile 1.0"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("home gallery tile 2.0", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Home_Gallery_2.0.webp"
          alt="Home Gallery Tile 2.0"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile naturemark waterproof hardwood", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_NatureMark_HW_logo.webp"
          alt="Colortile Naturemark Waterproof Hardwood"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("luxury flooring destination 2.0", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Luxury_Flooring_Destination_1_logo.webp"
          alt="Luxury Flooring Destination 2.0"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("color destination", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Color_Destination_White_1_Logo.webp"
          alt="Color Destination"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("elite performance waterproof flooring", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/COLORTILE_Pro_Elite_Performance_Plank_ft_COREtecTech.webp"
          alt="Elite Performance Waterproof Flooring"
        />
      ) : product.collection_facet
          .toLowerCase()
          .startsWith("colortile design statement flooring", 0) ? (
        <img
          src="https://mobilemarketing-res.cloudinary.com/image/upload/v1768193514/pdp-brand-logos/Korlok.webp"
          alt="Colortile Design Statement Flooring"
        />
      ) : (
        <p>{product.brand_facet}</p>
      )}
    </div>
  );
}

export default ProductBrandLogos;
